import { SelectColumnsWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('SelectColumns')
export class SelectColumnsNodeSchemaProvider extends SchemaProvider<SelectColumnsWorkflowNode> {}
